import React from 'react';
import { StoreContainer } from './store';

function CheckEnabledCookingOrder() {
  const storeContainer = StoreContainer.useContainer();

  const change = (selected) => {
    storeContainer.setEnabledCookingOrder(selected.target.checked);
    window.location.reload();
  };

  return (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="enabled_cooking_order"
        checked={storeContainer.enabledCookingOrder}
        onChange={change}
      />
      <label className="form-check-label" htmlFor="enabled_cooking_order">
        調理中を表示する
      </label>
    </div>
  );
}

export default CheckEnabledCookingOrder;
